import OrderCardWrapper from "@/Components/Order/OrderCardWrapper";
import useLiveFilters from "@/shared/atoms/useLiveFilters";
import { useSetLiveModal } from "@/shared/atoms/useLiveModal";
import { useSetLiveOrder } from "@/shared/atoms/useLiveOrder";
import useLiveSearch from "@/shared/atoms/useLiveSearch";
import useLiveSource from "@/shared/atoms/useLiveSource";
import { useSetModal } from "@/shared/atoms/useModal";
import useOrderPage from "@/shared/atoms/useOrderPageAtom";
import useOrderSort from "@/shared/atoms/useOrderSortAtom";
import useCommon from "@/shared/hooks/useCommon";
import useCouriersHook from "@/shared/hooks/useCouriersHook";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import useSystemTrackerHook from "@/shared/hooks/useSystemTrackerHook";
import useUserSettingsHook from "@/shared/hooks/useUserSettingsHook";
import { OrderStatus } from "@/shared/utils/enum";
import {
  filterAndSortLiveOrder,
  getCourierName,
  hasSwitch,
} from "@/shared/utils/helpers";
import { useMemo } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { modalNameEnum } from ".";
import OrderCard from "@/Components/Order/OrderCard";
import { cn } from "@/shared/utils/cn";

const itemsPerRow = {
  0: 1,
  1: 1,
  2: 2,
  3: 2,
};

const Lane = ({ dayOrders = [], s, list, i }) => {
  const [source] = useLiveSource();
  const [sortValues] = useOrderSort();
  const [pageValues] = useOrderPage();
  const [filters] = useLiveFilters();

  const couriers = useCouriersHook();

  const [search] = useLiveSearch();
  const setModalName = useSetLiveModal();
  const setOrder = useSetLiveOrder();
  const { showTipsOnLive } = useSystemTrackerHook();
  const setModal = useSetModal();
  const t = useCommon();
  const isMobile = useIsMobileHook();
  const { showOnlyNewOrders, showOrderCount } = useUserSettingsHook();

  const filteredOrders = useMemo(() => {
    return filterAndSortLiveOrder(
      dayOrders,
      s.value,
      search,
      sortValues,
      couriers,
      pageValues,
      source
    );
  }, [dayOrders, s.value, search, sortValues, couriers, pageValues, source]);

  if (search !== "" && filteredOrders.length === 0) {
    return null;
  }

  return (
    <Droppable
      // @ts-ignore
      style={{ transform: "none" }}
      key={`${s.value}`}
      droppableId={`${s.id}`}
    >
      {(provided) => (
        <div
          ref={provided.innerRef}
          className={cn(
            "max-w-[unset] p-[1rem] md:min-h-[calc(100vh-27rem)] flex-[1_0_100%] md:flex-[1_0_25%]",
            showOnlyNewOrders || list.length === i + 1
              ? ""
              : "md:border-r md:border-dashed md:border-dark"
          )}
        >
          <OrderCardWrapper
            title={t(`orders_live.${s.translationKey}`)}
            statues={s.value}
            orderDate={dayOrders}
          >
            {provided.placeholder}
            <div
              className={cn(
                "grid grid-cols-1",
                `lg:grid-cols-${itemsPerRow[filters.length]}`
              )}
            >
              {filteredOrders.map((order, index) => (
                <div
                  key={order?.order_information?.item_id}
                  className={cn("mx-0 md:mx-2")}
                >
                  <Draggable
                    isDragDisabled={
                      isMobile ||
                      showOnlyNewOrders ||
                      order.order_information.order_status ===
                        OrderStatus.HANDED_OVER
                    }
                    draggableId={`${order?.order_information?.item_id}`}
                    index={index}
                  >
                    {(provided, snapshot) => {
                      return (
                        <OrderCard
                          showOrderCount={showOrderCount}
                          showTipsOnLive={showTipsOnLive}
                          order={order}
                          isDragging={snapshot.isDragging}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          onClick={() => setModal("order", order)}
                          onTimeClick={() => {
                            setOrder(order);
                            setModalName(modalNameEnum.TIME_MODAL);
                          }}
                          courier={getCourierName(order, couriers)}
                          hasSwitch={hasSwitch(order)}
                        />
                      );
                    }}
                  </Draggable>
                </div>
              ))}
            </div>
          </OrderCardWrapper>
        </div>
      )}
    </Droppable>
  );
};

export default Lane;
